(() => {
  const sections = document.querySelectorAll('.dartsrx-testimonials');

  sections.forEach((section) => {
    const track = section.querySelector('[data-dartsrx-testimonials-track]');
    const previous = section.querySelector('[data-dartsrx-testimonials-prev]');
    const next = section.querySelector('[data-dartsrx-testimonials-next]');

    if (!track || !previous || !next) return;

    const getStep = () => {
      const card = track.querySelector('.dartsrx-testimonials__card');
      if (!card) return track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
      return card.getBoundingClientRect().width + gap;
    };

    previous.addEventListener('click', () => {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });
  });
})();
